import { AuditColumnModel } from "src/app/model";

export interface PlantListModel extends Pick<AuditColumnModel, "_id"> {
  name: string;
  image: string;
}